import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { AccountFilterPayload, AccountDetail, AccountsList } from 'src/app/models/account';

const controllerRoute = '/member-accounting';

@Injectable()
export class AccountService {

    constructor(
        private apiService: ApiService,
    ) {
    }

    public getMemberAccountsList(): Observable<AccountsList> {
        return this.apiService.get(`${controllerRoute}/accounts`).pipe(
            map((response: AccountsList) => {
                return response;
            }),
        );
    }

    public getMemberAccounttransactions(payload?: AccountFilterPayload): Observable<AccountDetail> {
        if (payload)
            return this.apiService.post(`${controllerRoute}/account-transactions`, payload).pipe(
                map((response: AccountDetail) => {
                    return response;
                }),
            );
        else
            return this.apiService.get(`${controllerRoute}/account-transactions`).pipe(
                map((response: AccountDetail) => {
                    return response;
                }),
            );
    }
} 